// extracted by mini-css-extract-plugin
export default {"Container":"MyPharmacy_Container__S67xW","PharmacyName":"MyPharmacy_PharmacyName__M7I68","PharmacyAddress":"MyPharmacy_PharmacyAddress__35--N"};